import React from "react"
import styled from "styled-components"
import icon1 from "../images/icons/reserach-icon.svg"
import icon2 from "../images/icons/analise-icon.svg"
import icon3 from "../images/icons/experience-icon.svg"

const StyledCard = styled.div`
  padding: 26px 22px;
  display: flex;
  align-items: center;
  background-color: #f9d6c1;
  border-radius: 8px;
  box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  img {
    margin-right: 16px;
    width: 48px;
    height: 48px;
    @media (min-width: 1024px) {
      width: 64px;
      height: 64px;
      margin-right: 32px;
    }
  }
  p {
    font-family: "Made Bold", sans-serif;
    line-height: 32px;
    letter-spacing: 1px;
    color: #151515;
    font-size: 20px;
    text-align: left;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
    @media (min-width: 1024px) {
      font-size: 24px;
      line-height: 38px;
    }
  }
  &:last-child {
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    margin-bottom: 0;
    margin-right: 15px;
  }
  @media (min-width: 1024px) {
    padding: 27px 40px;
    margin-right: 30px;
    &:last-child {
      margin-right: 0;
    }
  }
`

const data = [
  {
    icon: icon1,
    desc: (
      <p>
        Badania rynku <br />i marketing
      </p>
    ),
  },
  {
    icon: icon2,
    desc: (
      <p>
        Produkty cyfrowe <br />i e-commerce
      </p>
    ),
  },
  {
    icon: icon3,
    desc: (
      <p>
        Identyfikacja <br />
        wizualna i druk
      </p>
    ),
  },
]

const HeroCards = () => {
  return (
    <>
      {data.map(({ icon, desc }) => (
        <StyledCard key={icon}>
          <img src={icon} alt={desc} />
          {desc}
        </StyledCard>
      ))}
    </>
  )
}

export default HeroCards
